import { useMemo, useState } from "react"

const DEFAULT_SEARCH = { isSearching: false, term: null, lowered: null }

export function useDatasourceMappingSearch() {
  const [search, setSearch] = useState(DEFAULT_SEARCH)

  const actions = useMemo(
    () => ({
      reset: () => {
        setSearch(() => DEFAULT_SEARCH)
      },
      set: value => {
        setSearch(() => ({
          isSearching: value != null,
          term: value,
          lowered: value != null ? value.toLowerCase() : null,
        }))
      },
    }),
    []
  )

  return useMemo(
    () => ({
      search,
      actions,
    }),
    [actions, search]
  )
}
